/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { EntityDataApi } from "../../IndexedDBApi";
import { AreaDivisionLocationLabelBase } from "../../../../schema/generated/AreaDivisionLocationLabel";
import { idbEntityDefs } from "../../generated/entityDefs";

// 固有処理を持たない薄いDataApi。共通CRUD/キャッシュはEntityDataApiに集約。
export class AreaDivisionLocationLabelDataApi extends EntityDataApi<AreaDivisionLocationLabelBase> {
  public readonly def = idbEntityDefs.AreaDivisionLocationLabel;
}